import { render, staticRenderFns } from "./MultiProductModal.vue?vue&type=template&id=131c6d5e&scoped=true"
import script from "./MultiProductModal.vue?vue&type=script&lang=ts"
export * from "./MultiProductModal.vue?vue&type=script&lang=ts"
import style0 from "./MultiProductModal.vue?vue&type=style&index=0&id=131c6d5e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131c6d5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131c6d5e')) {
      api.createRecord('131c6d5e', component.options)
    } else {
      api.reload('131c6d5e', component.options)
    }
    module.hot.accept("./MultiProductModal.vue?vue&type=template&id=131c6d5e&scoped=true", function () {
      api.rerender('131c6d5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/MultiProductModal.vue"
export default component.exports